import script from './select.vue_vue_type_script_lang.mjs';
export { default } from './select.vue_vue_type_script_lang.mjs';
import { render } from './select.vue_vue_type_template_id_33774f85_lang.mjs';

script.render = render;
script.__file = "packages/components/select/src/select.vue";
//# sourceMappingURL=select.mjs.map
